import { render, staticRenderFns } from "./Add-Extension-List.vue?vue&type=template&id=0a8063ee&"
import script from "./Add-Extension-List.vue?vue&type=script&lang=js&"
export * from "./Add-Extension-List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports